import { apiError } from '../../utils/errors';

export interface SubmitAdditionalTradeReferencesResponse {
  message: string;
  submissionStatus: string;
  createdTradeReferences: number;
}

export const submitAdditionalTradeReferences = async (
  urlSlug: string,
  publicId: string,
  responses: Record<string, unknown>,
): Promise<SubmitAdditionalTradeReferencesResponse> => {
  const url = `${process.env.REACT_APP_API_URL}/submissions/${urlSlug}/${publicId}/additional-trade-references`;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      responses,
    }),
  });

  const responseJson = await response.json();

  if (!response.ok) {
    throw apiError(response.status, responseJson?.message || 'Failed to submit additional trade references', responseJson?.code);
  }

  return responseJson.data;
};
